var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2105 0.0332031H3.78947C1.70105 0.0332031 0 1.70899 0 3.76638V14.5511C0 14.717 0.101053 14.8664 0.261053 14.9327C0.311579 14.9576 0.370526 14.9659 0.421053 14.9659C0.530526 14.9659 0.64 14.9244 0.715789 14.8415L2.75368 12.8422C2.98947 12.6099 3.30947 12.4771 3.64632 12.4771H12.2105C14.2989 12.4771 16 10.8013 16 8.74395V3.76638C16 1.70899 14.2989 0.0332031 12.2105 0.0332031ZM4.63158 7.29216C4.05053 7.29216 3.57895 6.82759 3.57895 6.25517C3.57895 5.68275 4.05053 5.21817 4.63158 5.21817C5.21263 5.21817 5.68421 5.68275 5.68421 6.25517C5.68421 6.82759 5.21263 7.29216 4.63158 7.29216ZM8 7.29216C7.41895 7.29216 6.94737 6.82759 6.94737 6.25517C6.94737 5.68275 7.41895 5.21817 8 5.21817C8.58105 5.21817 9.05263 5.68275 9.05263 6.25517C9.05263 6.82759 8.58105 7.29216 8 7.29216ZM11.3684 7.29216C10.7874 7.29216 10.3158 6.82759 10.3158 6.25517C10.3158 5.68275 10.7874 5.21817 11.3684 5.21817C11.9495 5.21817 12.4211 5.68275 12.4211 6.25517C12.4211 6.82759 11.9495 7.29216 11.3684 7.29216Z",
    fill: "#474554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.99f258ad0f025f5d299b50eef00f315b.svg";
export { ForwardRef as ReactComponent };